module.exports = __webpack_public_path__ + "static/img/logo.f3eaf8b7.png";